import Vue from 'vue';
import Router from 'vue-router';

import IndexPage from '@/views/Index';
import AdminPage from '@/views/Admin';
import AudioPreachingsPage from '@/views/AudioPreachings';
import MusicPage from '@/views/Music';
import NextStepsPage from '@/views/NextSteps';
import ServicesPage from '@/views/Services';
import QuestionPage from '@/views/Question';
import QuestionAnswerPage from '@/views/QuestionAnswer';
import AnnouncementsPage from '@/views/Announcements';
import CreateAnnouncementPage from '@/views/CreateAnnouncement';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    // if (to.hash) {
    //   return { selector: to.hash };
    // }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: IndexPage,
    },
    {
      path: '/admin',
      component: AdminPage,
    },
    {
      path: '/audio_preachings',
      component: AudioPreachingsPage,
    },
    {
      path: '/music',
      component: MusicPage,
    },
    {
      path: '/next_steps',
      component: NextStepsPage,
    },
    {
      path: '/services',
      component: ServicesPage,
    },
    {
      path: '/question',
      component: QuestionPage,
    },
    {
      path: '/announcements',
      component: AnnouncementsPage,
    },
    {
      path: '/create_announcement',
      component: CreateAnnouncementPage,
    },
    {
      path: '/question/:link',
      component: QuestionAnswerPage,
      props: true,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
